import { useScreen } from 'vue-screen'

export function createHoverEvent(id, { message, icon, element }, { commit, remove }) {
	const screen = useScreen()

	if (!element || screen.touch) {
		return false
	}

	let revertCommit = null

	function onMouseEnter() {
		revertCommit = commit()
	}

	function onMouseLeave() {
		revertCommit?.()
		revertCommit = null
	}

	function destroy() {
		onMouseLeave()
		element.removeEventListener('mouseenter', onMouseEnter)
		element.removeEventListener('mouseleave', onMouseLeave)
		remove()
	}

	element.addEventListener('mouseenter', onMouseEnter)
	element.addEventListener('mouseleave', onMouseLeave)

	return {
		id,
		type: 'hover',
		message,
		icon,
		element,
		destroy,
	}
}
